import BaseModel from '@danhoss/model/BaseModel';
import {ModelType} from '@danhoss/model/types';

export class CartItemModel extends BaseModel {
    constructor() {
        super();

        this._product = new ModelType('ProductModel');
        this._index = Number;
        this._quantity = Number;
        this._totalPrice = String;
        this._result = String;
        this._personalizedFields = Array;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get index() {
        return this._index;
    }

    set index(value) {
        this._index = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get totalPrice() {
        return this._totalPrice;
    }

    set totalPrice(value) {
        this._totalPrice = value;
    }

    get result() {
        return this._result;
    }

    set result(value) {
        this._result = value;
    }

    get personalizedFields() {
        return this._personalizedFields;
    }

    set personalizedFields(value) {
        this._personalizedFields = value;
    }
}
